export const TIME_FORMAT = 'MMM Do YYYY [at] h:mm a'
export const CONDENSED_LOG_SIZE = 5
